export default "__VITE_ASSET__BnjKdHxs__"